/*
 * Copyright (c) 2019-2023 ServiceActivator Inc. All Rights Reserved.
 *
 * Unauthorized copying of the code in this file, completely or partially,
 * via any medium is strictly prohibited.
 *
 * Proprietary and Confidential.
 *
 * Written by Shivam Mishra <shivam.mishra@wakencode.com>, 6 2023
 *
 */

import { AppDispatch } from "../model/store/store";
import axios from "axios";
import saveAs from "file-saver";
import JSZip from "jszip";

/** get header with authorization token */
export const getHeaders = async (dispatch: AppDispatch) => {  
  return {
    headers: {
      'x-api-key': `${process.env.REACT_APP_API_KEY}`,
    },
  };
};

export const downloadImageFromUrl = async (url: string, fileName: string) => {
  const imageExtension = url.includes(".png")
    ? "png"
    : url.includes(".jpg")
    ? "jpg"
    : "jpeg";
  axios({
    method: "get",
    url: url + `&${new Date().getTime()}`, //This param is added to resolve issue of CORS while downloading images - https://www.hacksoft.io/blog/handle-images-cors-error-in-chrome
    responseType: "blob", // important
  })
    .then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const a = document.createElement("a");
      a.style.display = "none";
      a.href = url;
      a.download = `${fileName}.${imageExtension}`; // Provide the name you want
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
    })
    .catch((error) => {
      console.error("Download failed:", error);
    });
};

export const downloadTechImagesZip = async (
  techImages: any[],
  woName?: string,
  setLoading?: (val: boolean) => void
) => {
  try {
    setLoading?.(true);

    const zip = new JSZip();

    const fetchAndAddToZip = async (url: string, name: string) => {
      url = url + `&${new Date().getTime()}`;
      const response = await fetch(url);
      const blob = await response.blob();
      zip.file(name, blob);
    };

    const downloadPromises = techImages.map((image) =>
      fetchAndAddToZip(image.imageUrl || image.url, image.originalFileName || `${image.uid || image.id}.jpg`)
    );

    await Promise.all(downloadPromises);

    const fileName = `Technician_Images${woName ? `(${woName})` : ""}.zip`;
    const content = await zip.generateAsync({ type: "blob" });
    saveAs(content, fileName);
  } catch (error) {
    console.error("ZIP download failed:", error);
  } finally {
    setLoading?.(false);
  }
};
